import React, { useState, useEffect } from 'react';
import axios from 'axios';
//import 'bootstrap/dist/css/bootstrap.min.css';

const API_URL = process.env.REACT_APP_API_URL;
const GET_PERIODS_URL = `${API_URL}/Custom/GetExamPeriods`;
const GET_USERS_URL = `${API_URL}/Custom/GetAssignableUsers`;
const GET_TIMESLOTS_URL = `${API_URL}/Custom/GetTimeSlots`;
const GET_AVAILABILITY_URL = `${API_URL}/Custom/GetFacultyAvailability`;
const POST_AVAILABILITY_URL = `${API_URL}/Custom/SetFacultyAvailability`;
const DELETE_AVAILABILITY_URL = `${API_URL}/Custom/ClearFacultyAvailability`;

export default function FacultyAvailabilityComponent() {
    const [examPeriods, setExamPeriods] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [status, setStatus] = useState('');

    useEffect(() => {
        axios.get(GET_PERIODS_URL).then(res => setExamPeriods(res.data || [])).catch(console.error);
        axios.get(GET_USERS_URL).then(res => setUsers(res.data || [])).catch(console.error);
    }, []);

    useEffect(() => {
        if (!selectedPeriod || !selectedUser) {
            setTimeSlots([]);
            setSelectedSlots([]);
            return;
        }
        axios.get(`${GET_TIMESLOTS_URL}?examPeriodId=${selectedPeriod}`)
            .then(res => setTimeSlots(res.data || []))
            .catch(console.error);
        axios.get(`${GET_AVAILABILITY_URL}?userId=${selectedUser}`)
            .then(res => setSelectedSlots(res.data.map(x => x.timeSlotId)))
            .catch(console.error);
    }, [selectedPeriod, selectedUser]);

    const toggleSlot = id => {
        setSelectedSlots(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    const handleSave = async () => {
        if (!selectedUser) return;
        setStatus('Kaydediliyor...');
        try {
            await axios.delete(`${DELETE_AVAILABILITY_URL}?userId=${selectedUser}`);
            await axios.post(POST_AVAILABILITY_URL, { userId: selectedUser, timeSlotIds: selectedSlots });
            setStatus('Kaydedildi.');
        } catch (err) {
            setStatus('Hata: ' + (err.response?.data || err.message));
        }
    };

    const handleClear = async () => {
        if (!selectedUser) return;
        setStatus('Temizleniyor...');
        try {
            await axios.delete(`${DELETE_AVAILABILITY_URL}?userId=${selectedUser}`);
            setSelectedSlots([]);
            setStatus('Temizlendi.');
        } catch (err) {
            setStatus('Hata: ' + (err.response?.data || err.message));
        }
    };

    return (
        <div className="container mt-4">
            <h2 className="mb-4">Öğretim Elemanı Müsaitlik Ayarı</h2>

            {/* Dönem Seçimi */}
            <div className="mb-3">
                <label><strong>Sınav Dönemi:</strong></label>
                <select className="form-control" value={selectedPeriod || ''} onChange={e => setSelectedPeriod(Number(e.target.value))}>
                    <option value="" disabled>Seçiniz</option>
                    {examPeriods.map(ep => <option key={ep.id} value={ep.id}>{ep.name}</option>)}
                </select>
            </div>

            {/* Kullanıcı Seçimi */}
            {selectedPeriod && (
                <div className="mb-3">
                    <label><strong>Öğretim Elemanı:</strong></label>
                    <select className="form-control" value={selectedUser || ''} onChange={e => setSelectedUser(Number(e.target.value))}>
                        <option value="" disabled>Seçiniz</option>
                        {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                    </select>
                </div>
            )}

            {/* Slotlar */}
            {selectedUser && (
                <>
                    {/* Action Buttons */}
                    <div className="mt-3">
                        <button className="btn btn-danger mr-2" onClick={handleSave}>Kaydet</button>
                        <button className="btn btn-outline-danger" onClick={handleClear}>Temizle</button>
                    </div>
                    <div className="mb-2 mt-2">
                        <button
                            className="btn btn-sm m-1"
                            style={{ border: '1px solid #007bff', backgroundColor: selectedSlots.length === timeSlots.length ? '#007bff' : 'transparent', color: selectedSlots.length === timeSlots.length ? '#fff' : '#007bff' }}
                            onClick={() => setSelectedSlots(selectedSlots.length === timeSlots.length ? [] : timeSlots.map(ts => ts.id))}
                        >{selectedSlots.length === timeSlots.length ? 'Temizle' : 'Hepsini Seç'}</button>
                    </div>

                    {Array.from(new Set(timeSlots.map(ts => ts.exactDate))).sort().map(date => {
                        const ids = timeSlots.filter(ts => ts.exactDate === date).map(ts => ts.id);
                        const allSel = ids.every(id => selectedSlots.includes(id));
                        return (
                            <div key={date} className="mb-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6>{new Date(date).toLocaleDateString('tr-TR', { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' })}</h6>
                                    <button
                                        className="btn btn-sm m-1"
                                        style={{ border: '1px solid #007bff', backgroundColor: allSel ? '#007bff' : 'transparent', color: allSel ? '#fff' : '#007bff' }}
                                        onClick={() => setSelectedSlots(prev => allSel ? prev.filter(x => !ids.includes(x)) : [...new Set([...prev, ...ids])])}
                                    >{allSel ? 'Kaldır' : 'Seç'}</button>
                                </div>
                                <div className="d-flex flex-wrap">
                                    {ids.map(id => {
                                        const ts = timeSlots.find(x => x.id === id);
                                        const sel = selectedSlots.includes(id);
                                        return (
                                            <button
                                                key={id}
                                                className="btn btn-sm m-1"
                                                style={{ border: '1px solid #dc3545', backgroundColor: sel ? '#dc3545' : 'transparent', color: sel ? '#fff' : '#dc3545' }}
                                                onClick={() => toggleSlot(id)}
                                            >{`${ts.startTime.substring(0, 5)} - ${ts.endTime.substring(0, 5)}`}</button>
                                        );
                                    })}
                                </div>

                            </div>
                        );
                    })}

                    {/* Action Buttons */}
                    <div className="mt-3">
                        <button className="btn btn-danger mr-2" onClick={handleSave}>Kaydet</button>
                        <button className="btn btn-outline-danger" onClick={handleClear}>Temizle</button>
                    </div>
                    {status && <div className="alert alert-info mt-3">{status}</div>}
                </>
            )}

        </div>
    );
}
